"use strict";
/**
 * Component: Data Grid Field - Ajuntament de Manresa
 * Fitxer: DataGridField.tsx
 * Llenguatge: TypeScrypt
 * Autor: Jordi Riu
 * Versió: 1.2
 * Data: 17/11/2017
 * (c) Ajuntament de Manresa - nov 2017 - Departament de Sistemes d'Informació
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var DataGridField =
/** @class */
function (_super) {
  __extends(DataGridField, _super);

  function DataGridField() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DataGridField.prototype.render = function () {
    return null;
  };

  DataGridField.defaultProps = {
    visible: true
  };
  return DataGridField;
}(React.Component);

exports.default = DataGridField;